import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {FaqCategory} from '../../model/FaqCategory';
import {FaqCategoryService} from '../../services/faq-category.service';
import {Event} from '../../model/Event';
import {EventService} from '../../services/event.service';
import {AdminPageModelComponent} from "../../components/admin/admin-page-model/admin-page-model.component";
import {CommonModule} from "@angular/common";
import {ListEventsComponent} from "./list-events/list-events.component";
import {CreateEventActionComponent} from "./create-event-action/create-event-action.component";
import {DynamicModalFormComponent} from "../../components/common/dynamic-modal-form/dynamic-modal-form.component";

@Component({
    selector: 'app-events',
    templateUrl: './events.component.html',
    imports: [
        CommonModule,
        AdminPageModelComponent,
        CreateEventActionComponent,
        ListEventsComponent,
        DynamicModalFormComponent,
    ],
    styleUrl: './events.component.scss'
})
export class EventsComponent implements OnInit {
  $events: Observable<Event[]>;
  categories: Observable<FaqCategory[]>;

  toEdit: Event;
  toRemove: Event;

  search = '';

  @ViewChild('removeeventmodal') removeeventmodal: TemplateRef<any>;


  constructor(private eventService: EventService,
              private faqCategoryService: FaqCategoryService) {
  }

  createEvent($event: Event): void {
    this.eventService.createObject($event);
  }

  ngOnInit(): void {
    this.$events = this.eventService.getObjects();
    this.categories = this.faqCategoryService.getAllCategories();
  }

  askToRemove(event: Event): void {
    this.toRemove = Object.assign({}, event);
  }

  remove(): void {
    this.eventService.deleteObject(this.toRemove);
    this.toRemove = undefined;
  }

  editEvent(event: Event): void {
    this.toEdit = Object.assign({}, event);
  }
}
